export { default } from './log';
